// Sadly, there are no modern type definitions for NanoEvents 2. :(
// @ts-ignore
import NanoEvents from 'nanoevents';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const popupEmitter = new NanoEvents<any>();


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const onPopup = (funcRef: (id: string) => any): Function => {
    return popupEmitter.on('popup', funcRef);
};

export const setGlobalPopupId = (id: string): void => {
    popupEmitter.emit('popup', id);
};

export const clearPopups = (): void => {
    popupEmitter.emit('popup', '');
};
